import { lazy, Suspense } from 'react';

const PrivatePage = lazy(() => import('./PrivatePage'));
export const PrivateRoute = () => (
  <Suspense fallback={<div>Werkplek laden…</div>}>
    <PrivatePage />
  </Suspense>
);
